declare global {
    interface Window {
      gtag?: (...args: any[]) => void;
    }
  }

export const gtag_report_conversion = (url?: string) => {
    const callback = () => {
        if (typeof url !== "undefined") {
          setTimeout(() => {
            // window.open(url, "_blank"); // 3 saniye sonra yönlendirme
            //window.location.href = url
          }, 1000);
        }
      };
    
  console.log('deneme gtag')
    if (typeof window !== "undefined" && typeof window.gtag === "function") {
      window.gtag("event", "conversion", {
        send_to: "AW-626795656/tTVgCLCDqLgaEIjJ8KoC",
        event_callback: callback,
      });
      window.gtag("event", "conversion", {
        send_to: "AW-626795656/YyVrCPTqs7oDEIjJ8KoC",
        event_callback: callback,
      });

    }
  };
  